import moment from "moment";
import { setLoading, unsetLoading } from "../../../store/loading/loading.slice";
import { useCallback, useEffect, useState } from "react";
import TableRowCommon from "../../../components/table/TableRowCommon";
import { IconButton, useMediaQuery, useTheme } from "@mui/material";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { NavigateFunction, useNavigate } from "react-router-dom";
import { routeName } from "../../../routes/routeName";
import OptionsButtonCustom from "../../../components/option-button/OptionsButtonCustom";
import SwitchCustom from "../../../components/switch/SwitchCustom";
import { AcademicYearApi } from "../../../api/academic-year/academic-year.api";
import { dateToView } from "../../../utils/date.utils";
const ManageState = () => {
    const { t } = useTranslation();
    const theme = useTheme()
    const matches = useMediaQuery(theme.breakpoints.up("md"));
    const navigate: NavigateFunction = useNavigate();

    const dispatch = useDispatch();
    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(10);
    const [totalItems, setTotalItems] = useState<number>(0);
    const [sortBy, setSortBy] = useState<string>("modified_date");
    const [sortType, setSortType] = useState<string>("DESC")
    const [keyword, setKeyword] = useState<string>("");
    const [status, set_status] = useState<string>("");


    const [data, setData] = useState<any[]>([{}]);
    const [startDate, setStartDate] = useState<string>("");
    const [endDate, setEndDate] = useState<string>("");
    const [date_range, set_date_range] = useState<string[]>([]);

    const handleChangeDateRange = (date_value: string[]) => {
        set_date_range(date_value);
        setStartDate(date_value[0]);
        setEndDate(date_value[1]);
    }
    const handleClearDateRange = () => {
        set_date_range([]);
        setStartDate("");
        setEndDate("");
    }
    const handleRequestSort = (sortBy: string, sortType: string) => {
        setSortBy(sortBy)
        setSortType(sortType)
    }

    const headCells = [
        {
            id: "id_comment", width: 400, sortable: false, disablePadding: false, align: 'center', label: t("SETUP_COURSE_OPENING_ACADEMIC_YEAR")
        },
        {
            id: "subject_name", disablePadding: false, width: 240, align: "center", label: t("SETUP_COURSE_OPENING_START_DATE")
        },

        {
            id: "detail", disablePadding: false, align: "center", width: 240, label: t("SETUP_COURSE_OPENING_END_DATE")
        },


        {
            id: "action", disablePadding: false, align: "left", padding: "0 8px", width: 180, class: matches && data.length > 0, label: ""
        },
    ];
    const renderData = (objData: any, no: any) => {
        no = page * pageLimit - pageLimit + no + 1
        const {
            academic_year_start,
            created_by,
            created_date,
            modified_date,
            academic_year,
            id_academic_year,
            academic_year_end

        } =
            objData;
        const objRenderData = {
            key: no,
            id: no,
            obj: objData,
            columns: [
                { option: "TEXT", align: "center", label: academic_year || "-" },

                {
                    option: "TEXT",
                    align: "center",
                    label: dateToView(academic_year_start) || "-",
                },


                {
                    option: "TEXT",
                    align: "center",
                    label: dateToView(academic_year_end) || "-",
                },
                {
                    option: "COMPONENT",
                    align: "center",
                    class: matches && data.length > 0,
                    component: <div className='flex justify-center items-center'>
                        {/* <IconButton onClick={() => navigate(routeName.admission.applicants_detail)}>
                            <ArrowForwardIosIcon />
                        </IconButton> */}
                        <OptionsButtonCustom
                            enableEdit
                            enableView
                            // enableDelete
                            onViewClick={() => navigate(routeName.admission.SetupCourseOpeningView.replace(':id',id_academic_year))}
                            onEditClick={() => navigate(routeName.admission.SetupCourseOpeningDetail.replace(':id',id_academic_year))}
                            // onDeleteClick={() => handleDeleteList(id_comment)}
                        />
                    </div>
                },
            ],
        };
        return <TableRowCommon
            {...objRenderData}
        />;
    };


    const handleGetData = useCallback(async () => {
        let query: any = {
            page: page,
            limit: pageLimit
        }
        if (keyword) query = { ...query, search: keyword }
        // if (startDate) query = { ...query, start_date: moment(startDate).format("YYYY-MM-DD") }
        // if (endDate) query = { ...query, end_date: moment(endDate).format("YYYY-MM-DD") }
        dispatch(setLoading());
        await AcademicYearApi.getOnlyActiveAcademicYear(query).then((res) => {
            if (res.status < 300) {
                setData(res.data?.data?.items || []);
                setTotalItems(res.data?.data?.meta?.totalItems || 0)
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }, [page, pageLimit, status, keyword, startDate, endDate])

    useEffect(() => {
        handleGetData()
    },[handleGetData])


    return {
        page,
        pageLimit,
        setPage,
        setPageLimit,
        sortBy,
        sortType,
        handleRequestSort,
        headCells,
        renderData,
        data,
        totalItems,
        setKeyword,
        handleChangeDateRange,
        date_range,
        handleClearDateRange,

    }
}

export default ManageState